import './SingleCard.css'
export default function SingleCard({card,handleChoices,flipped,disabled}){
    return(
        <div className='single-card'>
            <div className={flipped?'flipped':''}>
                <img src={card.src} className='back'/>
                <img src='./images/cover.jpg' 
                    onClick={()=>{
                        if(disabled===false){
                            handleChoices(card);
                        }
                    }} className='front'/>
            </div>
        </div>
    )
}